<template>
	<div class="account">
		<div class="account-content" v-if="1">
			<div class="landing" @click="clickShow">
				<img src="../assets/Group 1271@2x.png" style="width: 35px; height: 35px" />
			</div>
			<div class="landing-group">
				<img src="../assets/image 29@2x.png" style="width: 106px; height: 106px" />
			</div>
			<div class="captchaLogin">
				<div class="mobile">
					<div class="mobile-title" :class="{ 'mobile-title1': ids == 1 }">手机验证码登录</div>
					<div class="bor-top" v-show="ids == 1"></div>
				</div>
				<!-- <div class="mobile" style="margin-left: 50px">
					<div class="mobile-title" :class="{ 'mobile-title1': ids == 2 }">账号密码登录</div>
					<div class="bor-top" v-show="ids == 2"></div>
				</div> -->
			</div>
			<template v-if="ids == 1">
				<div class="mobile-bor">
					<img src="../assets/Group 1268@2x.png" style="width: 11px; height: 16px; margin-left: 15px" />
					<input v-model="form.mobile" placeholder="手机号" class="input" />
				</div>
				<div class="mobile-bor" style="margin-top: 12px" v-if="!showNumber">
					<img src="../assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
					<input v-model="form.code" placeholder="输入短信验证码" class="input" />
					<div class="mobile-flex" style="white-space: nowrap;color: #FF2F17;" @click="SendCaptcha">发送验证码</div>
				</div>
				<div class="mobile-bor" style="margin-top: 12px" v-else>
					<img src="../assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
					<input v-model="form.code" placeholder="输入短信验证码" class="input" />
					<div class="mobile-flex">{{ showNumber }}</div>
				</div>
			</template>
			<template v-else>
				<div class="mobile-bor">
					<img src="../assets/contact_slices/Group 903@2x.png" style="width: 13px; height: 16px; margin-left: 15px" />
					<input placeholder="手机号码" class="input" />
				</div>
				<div class="mobile-bor" style="margin-top: 12px">
					<img src="../assets/Group 902@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
					<input placeholder="登录密码" class="input" />
				</div>
			</template>
			<div class="login" @click="clickLogin">登录</div>
			<!-- <div class="flex-pws">
				<span>忘记密码？</span>
				<span style="color: #eeeeee; padding: 0px 6px; padding-right: 10px">|</span>
				<span>立即注册</span>
			</div> -->
		</div>

		<div class="account-content1" v-else>
			<div class="landing">
				<img src="../assets/Group 1271@2x.png" style="width: 35px; height: 35px" />
			</div>
			<div class="landing-group">
				<img src="../assets/image 31@2x.png" style="width: 118px; height: 95px" />
			</div>
			<div class="registered">
				注册
				<span style="color: #ff2f17">百越回收</span>
			</div>
			<div class="registered-text">财富不浪费 · 回收更省心</div>
			<div class="mobile-bor">
				<img src="../assets/Group 1268@2x.png" style="width: 11px; height: 16px; margin-left: 15px" />
				<input placeholder="手机号" class="input" />
			</div>
			<div class="mobile-bor" style="margin-top: 12px">
				<img src="../assets/Group 902@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
				<input placeholder="请输入密码" class="input" />
			</div>
			<div class="mobile-bor" style="margin-top: 12px">
				<img src="../assets/Group 1272@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
				<input placeholder="请再次输入密码" class="input" />
			</div>
			<div class="mobile-bor" style="margin-top: 12px">
				<img src="../assets/Group 902@2x.png" style="width: 16px; height: 16px; margin-left: 15px" />
				<input placeholder="输入验证码" class="input" />
				<div class="mobile-flex">3n3d</div>
			</div>
			<div class="mobile-bor" style="margin-top: 12px">
				<img src="../assets/Group 1269@2x.png" style="width: 15px; height: 16px; margin-left: 15px" />
				<input placeholder="输入短信验证码" class="input" />
				<div class="mobile-flex">发送验证码</div>
			</div>
			<div class="mobile-bor1" style="margin-top: 12px">
				<div class="flex-slice">
					<img src="@/assets/recycling_slices/Slice 14@2x(1).png" style="width: 12px; height: 12px" />
				</div>
				<div class="have-read">
					已阅读并同意
					<span style="color: #ff2f17">「浙收卡用户服务协议」</span>
					和
					<span style="color: #ff2f17">「隐私政策」</span>
				</div>
			</div>
			<div class="login">登录</div>
			<div class="flex-pws">
				<span style="color: #aaaaaa">已有账号，</span>
				<span>请登录</span>
			</div>
		</div>
		<Verify
			mode="pop"
			@success="handleSuccess"
			:captchaType="captchaType"
			:imgSize="{ width: '400px', height: '200px' }"
			ref="verify"
		></Verify>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import Verify from '@/components/verifition/Verify';
import { sendSmsCode, smsLogin, memberUserGet } from '@/utils/api.js';
import { ElMessage } from 'element-plus';
let emit = defineEmits(['skipCompents','refreshSkip']);
let form = ref({});
let showNumber = ref(0);
const verify = ref(null);
const captchaType = ref('blockPuzzle');

let ids = ref(1);
const clickShow = () => {
	emit('skipCompents');
};

const SendCaptcha = () => {
	if (showNumber.value != 0) return false;
	const phoneRegex = /^1[3-9]\d{9}$/;
	if (!form.value.mobile) {
		ElMessage({
			message: '手机号不能为空',
			type: 'error',
		});
		return false;
	}
	if (!phoneRegex.test(form.value.mobile)) {
		ElMessage({
			message: '手机号格式不正确',
			type: 'error',
		});
		return false;
	}
	verify.value.show();
};

const sendSmsCodeClick = async (captchaVerification) => {
	const data = await sendSmsCode({
		mobile: form.value.mobile,
		scene: 1,
		captchaVerification,
	});
	if (data.code === 0) {
		showNumber.value = 60;
		infoNumber();
	} else {
		ElMessage({
			message: data.msg || '发送失败',
			type: 'error',
		});
	}
};

const handleSuccess = (res) => {
	sendSmsCodeClick(res.captchaVerification);
};
const clickLogin = async () => {
	const phoneRegex = /^1[3-9]\d{9}$/;
	if (!form.value.mobile) {
		ElMessage({
			message: '手机号不能为空',
			type: 'error'
		});
		return false;
	}
	if (!phoneRegex.test(form.value.mobile)) {
		ElMessage({
			message: '手机号格式正确',
			type: 'error'
		});
		return false;
	}
	if (!form.value.code) {
		ElMessage({
			message: '请输入验证码',
			type: 'error'
		});
		return false;
	}
	const res = await smsLogin({
		fromProxyId: '',
		mobile: form.value.mobile,
		code: form.value.code
	});
	console.log(res.msg);
	if (res.msg) {
		ElMessage({
			message: res.msg,
			type: 'error'
		});
	} else {
		infoatin();
		localStorage.setItem('londEssage', JSON.stringify(res.data));
	}
};
const infoatin = async () => {
	let res = await memberUserGet();
	localStorage.setItem('information', JSON.stringify(res.data));
	ElMessage({
		message: '登陆成功',
		type: 'success'
	});
	emit('refreshSkip');
};
const infoNumber = () => {
	setTimeout(() => {
		if (showNumber.value) {
			showNumber.value = showNumber.value - 1;
			infoNumber();
		}
	}, 1000);
};
</script>

<style lang="scss" scoped>
.account {
	position: fixed;
	z-index: 100;
	width: 100%;
	height: 100%;
	z-index: 999;
	background: rgba(0, 0, 0, 0.7);
	border-radius: 0px 0px 0px 0px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.account-content {
	width: 532px;
	height: 341px;
	background: #ffffff;
	border-radius: 7px;
	position: relative;
}

.account-content1 {
	width: 532px;
	background: #ffffff;
	border-radius: 7px;
	position: relative;
	padding-bottom: 50px;
}

.landing {
	position: absolute;
	top: -15px;
	right: -15px;
}

.landing:hover{
	cursor: pointer;
}

.landing-group {
	position: absolute;
	bottom: 0px;
}

.captchaLogin {
	display: flex;
	align-items: flex-start;
	justify-content: center;
	margin-top: 40px;
}

.mobile {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
.bor-top {
	width: 26px;
	height: 4px;
	background: #ff2f17;
	border-radius: 6px 6px 6px 6px;
	margin-top: 4px;
}
.mobile-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
// .mobile-title:hover {
// 	cursor: e-resize;
// }
.mobile-title1 {
	color: #ff2f17;
}
.mobile-bor {
	width: 320px;
	height: 42px;
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	display: flex;
	align-items: center;
	margin: auto;
	margin-top: 40px;
}
.mobile-bor1 {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: auto;
	margin-top: 40px;
}
.input {
	border: none;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #000;
	font-style: normal;
	text-transform: none;
	margin-left: 10px;
}
.input::placeholder {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
}
input:focus {
	outline: none;
	border: none;
}

.mobile-flex {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ff2f17;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-left: auto;
	margin-right: 20px;
}
.mobile-flex:hover {
	cursor: pointer;
}

.login {
	width: 320px;
	height: 42px;
	background: #ff2f17;
	border-radius: 7px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 42px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin: auto;
	margin-top: 32px;
}

.login:hover {
	cursor: pointer;
}

.flex-pws {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #ff2f17;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 14px;
}

.flex-pws:hover {
	cursor: pointer;
}

.registered {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 22px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 128px;
	margin-top: 40px;
}
.registered-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 13px;
	color: #333333;
	letter-spacing: 3px;
	font-style: normal;
	text-transform: none;
	margin-left: 128px;
	margin-top: 7px;
}

.flex-slice {
	width: 18px;
	height: 18px;
	background: #ff2f17;
	border-radius: 3px 3px 3px 3px;
	margin-top: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.have-read {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-top: 14px;
	padding-left: 7px;
}
.have-read:hover {
	cursor: pointer;
}
</style>
